export default [
  // 添加编辑学员
  {
    name: 'register-merchant',
    component: () => import(/* webpackChunkName: "registerMerchant" */ './register-merchant.vue'),
  },
  // 推荐关注小云爱学
  {
    name: 'share-xiaoyunaixue',
    component: () => import(/* webpackChunkName: "registerMerchant" */ './share-xiaoyunaixue.vue'),
  },
  // {
  //   name: 'pay',
  //   component: () => import(/* webpackChunkName: "pay" */ './pay.vue'),
  // },
];
